import script from "./VideoPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoPreview.vue?vue&type=script&lang=ts&setup=true"

import "./VideoPreview.vue?vue&type=style&index=0&id=7356a302&lang=scss"

const __exports__ = script;

export default __exports__